import { AbstractControl, AsyncValidatorFn } from '@angular/forms';
import { FormCategory, SearchType } from '@nrwl/rx-models';
import { Observable, of } from 'rxjs';
import { debounceTime, map, switchMap, take } from 'rxjs/operators';

import { FormCategoryService } from '@nrwl/rx-service-forms';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FormsValidatorsService {
  constructor(private categoryService: FormCategoryService) {}

  public categoryUniqValidator(allCategories: FormCategory[]): AsyncValidatorFn {
    return (control: AbstractControl | any): Observable<{ [key: string]: any } | null> => {
      const match = allCategories.find(
        (item) => item.name.toLowerCase() === control.value.toLowerCase() && !item.is_stock[0],
      );
      if (match) {
        return of({
          exists: {
            message: 'Folder with this name already exists. Please enter new name',
          },
        });
      } else {
        return control.parent.valueChanges.pipe(
          debounceTime(1000),
          take(1),
          switchMap((_) => this.categoryService.getFormCategories()),
          map((categories: any) => {
            if (
              categories.find(
                (item) =>
                  item.name.toLowerCase() === control.value.toLowerCase() && !item.is_stock[0],
              )
            ) {
              return { exists: true };
            }
            return null;
          }),
        );
      }
    };
  }

  public captureNameUniqValidator(names: string[]): AsyncValidatorFn {
    return (control: AbstractControl): Observable<{ [key: string]: any } | null> => {
      const match = names.find((name) => name.toLowerCase() === control.value.toLowerCase());
      if (match) {
        return of({ exists: true });
      }
      return of(null);
    };
  }

  public templateUniqValidator(type: SearchType): AsyncValidatorFn {
    return (control: AbstractControl): Observable<{ [key: string]: any } | null> => {
      return of(null);
    };
  }
}
